<template>
    <div class="row map">
        <l-map
            :ref="`mapaEndereco-${idServicoAtendimento}`"
            :zoom="zoom"
            :center="center"
            :bounds="bounds"
            :scrollWheelZoom="scrollWheelZoom"
        >
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <MarcadorMapa
                v-for="(coordenada, index) in coordenadas"
                :key="index"
                :lat="coordenada.lat"
                :long="coordenada.long"
                :icone="coordenada.icone"
                :texto="coordenada.texto"
            />
        </l-map>
    </div>
</template>

<script>
import { LMap, LTileLayer } from "vue2-leaflet";
import MarcadorMapa from "@/components/Mapa/MarcadorMapa";
import barramentoEndereco from "@/bus/endereco";

export default {
    props: {
        coordenadas: {
            type: Array,
            required: true,
            default: () => {
                return [{ texto: "", icone: "", lat: "0", long: "0" }];
            },
        },
        idServicoAtendimento: {
            type: String,
            default: ''
        }
    },
    components: { 
        LMap, 
        LTileLayer, 
        MarcadorMapa 
    },
    data() {
        return {
            center: ["-17.3085086", "-62.8432212"],
            bounds: null,
            zoom: 10,
            url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
            attribution: '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
            scrollWheelZoom:false
        };
    },
    created() {
        barramentoEndereco.$on("centralizarMapa", () => {
            this.$refs[`mapaEndereco-${this.idServicoAtendimento}`] &&
            this.$refs[`mapaEndereco-${this.idServicoAtendimento}`].mapObject.invalidateSize() &&
            this.$refs[`mapaEndereco-${this.idServicoAtendimento}`].mapObject._onResize();
        });
    },
    watch: {
        coordenadas() {
            this.centralizarMapa();
        }
    },
    computed: {
        desabilitarMapa() {
            return true;
        }
    },
    methods: {
        centralizarMapa () {
            this.bounds = [];
            this.coordenadas.forEach((element) => {
                if (element.texto != "Destino") {
                    if (element.texto == 'Origem') {
                        this.center = [`${element.lat}`, `${element.long}`];
                    }

                    this.bounds.push([`${element.lat}`, `${element.long}`]);
                }
            });
            this.zoom = 8;
        }
    },
    mounted() {
        this.centralizarMapa();
    },
};
</script>

<style scoped>
.map {
    width: fit-content;
    height: fit-content;
    display: contents;
    margin: 0;
}
</style>